import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAccount, useDisconnect } from 'wagmi';
import { shortenAddress } from '../utils/format';
import WalletModal from './WalletModal';
import '../App.css';

const Header = () => {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const [showWalletModal, setShowWalletModal] = useState(false);
  const location = useLocation();

  // Get page name based on route
  const getPageName = () => {
    const path = location.pathname;
    if (path === '/') return 'Dashboard';
    if (path === '/swap') return 'Swap';
    if (path === '/staking') return 'Staking';
    if (path === '/space') return 'Space';
    return 'DApp';
  };

  const handleConnectClick = () => {
    if (isConnected) {
      disconnect();
    } else {
      setShowWalletModal(true);
    }
  };

  return (
    <>
      <header className="app-header">
        <div className="app-header-container">
          <div className="app-brand">
            <img
              className="app-logo"
              src="/assets/logo-rabbit.png"
              alt="Little Rabbit"
            />
            <div className="app-brand-text">
              <div className="app-brand-title">Little Rabbit</div>
              <div className="app-brand-subtitle">{getPageName()}</div>
            </div>
          </div>

          <div className="app-header-spacer"></div>

          <div className="app-header-actions">
            <motion.button
              className="app-connect-btn"
              onClick={handleConnectClick}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isConnected ? shortenAddress(address) : 'Connect Wallet'}
            </motion.button>
          </div>
        </div>
      </header>

      <WalletModal 
        isOpen={showWalletModal} 
        onClose={() => setShowWalletModal(false)} 
      />
    </>
  );
};

export default Header;
